import React from 'react'

const ResidentInvoicesPayments = () => {
  return (
    <div>ResidentInvoicesPayments</div>
  )
}

export default ResidentInvoicesPayments